<template>
    <div class="no-owner">
        <div class="avatar-wraper">
            <img src="../../../../assets/image/live/shimian.png" class="avatar" />
        </div>
        <div class="tips nick">
            {{ ownerInfo.nick }}
        </div>
        <div class="tips other">
          المرساة ليست على الإنترنت ، دعنا نذهب للتسوق
        </div>
    </div>
</template>

<script>
export default {
  props: {
    ownerInfo: {}
  },
  data () {
      return {}
  },
  methods: {
  },
  computed: {}
}
</script>
<style type="scss" scoped>
    .no-owner {
        height: 100vh;
        width: 100vw;
        background-color: #494949;
    }
    .avatar {
        width: 3.5015625rem;
        height: 3.5015625rem;
        overflow: hidden;
    }
    .avatar-wraper {
        padding-top: 5.90625rem;
        text-align: center
    }
    .tips {
        font-family: PingFangSC-Regular;
        font-size: 0.6rem;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
    }
    .nick{
        padding-top: 0.6328125rem;
        line-height: 0.78046875rem;
    }
    .other{
        margin-top: 0.421875rem;
    }
</style>
